import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { camelToSnake } from 'projects/common/src/app/services/utils/utilities';
import { environment } from 'src/environments/environment';
import { format } from 'util';
import { ParameterHandlerService } from '../..';
import { Parameter } from '../../../classes';

@Injectable({
  providedIn: 'root',
})
export class LanguageService extends Parameter<string> {
  private readonly NO_MESSAGE_FOUND = '%s';
  private readonly NO_LANG_FOUND_IN_COLLETION = `no language file '%s' found for translate '%s'`;
  private readonly COLLECTION_NAME = 'language-collection';

  constructor(private parameterService: ParameterHandlerService, private cacheService: CacheService) {
    super();
    this.name = 'language';
  }

  public start(): Promise<string> {
    return new Promise((resolve) => {
      const prevValue = this.cacheService.session(this.name);
      const lang = prevValue || environment.lang;
      this.set(lang);
      resolve(lang);
    });
  }

  /**
   * Function to translate text
   * @param index string to translate
   * @param args arguments to translate option
   */
  public message(index: string, ...args: any[]): string {
    if (index && typeof index === 'string' && index.length > 0) {
      const currentLang = this.get();
      const value = camelToSnake(index);
      if (this.parameterService.parameters.containsKey(this.COLLECTION_NAME)) {
        const collection = this.parameterService.parameters.item(this.COLLECTION_NAME);
        if (collection && collection.value.count) {
          if (collection.value.containsKey(value.toLowerCase())) {
            const msg = collection.value.item(value);
            if (Array.isArray(args) && args.length && args[0]) {
              return format(msg, ...args);
            }
            return msg;
          }
          // info: Message intended exclusively for debugging in case of missing any translation
          // uncomment the following line to show the message
          // this.warn(this.NO_MESSAGE_FOUND, value);
          return format(this.NO_MESSAGE_FOUND, value);
        }
        this.error(this.NO_MESSAGE_FOUND);
        return format(this.NO_LANG_FOUND_IN_COLLETION, currentLang, value);
      }
      this.error('parámetro de colección de lenguaje no está listo');
      return format('parámetro de colección de lenguaje no está listo');
    }
  }
}
